import { c as _c } from "react/compiler-runtime";
import classnames from 'classnames';
import { styled } from '@classify/react-core-components/styles';
import { ListItemButton as MuiListItemButton, ListItemIcon, ListItemText } from '@mui/material';
const PREFIX = 'ListItem';
const classes = {
  iconContainerOnRight: `${PREFIX}-iconContainerOnRight`,
  itemSelected: `${PREFIX}-itemSelected`,
  listItemContainer: `${PREFIX}-listItemContainer`,
  listItem: `${PREFIX}-listItem`,
  primary: `${PREFIX}-primary`
};
const Root = styled('li')(({
  theme: {
    palette,
    typography
  }
}) => ({
  [`& .${classes.iconContainerOnRight}`]: {
    alignSelf: 'baseline',
    marginRight: 0
  },
  [`& .${classes.itemSelected}`]: {
    backgroundColor: palette.action.selected,
    pointerEvents: 'none'
  },
  [`& .${classes.listItemContainer}`]: {
    listStyle: 'none'
  },
  [`& .${classes.listItem}`]: {
    color: 'inherit !important'
  },
  [`& .${classes.primary}`]: {
    fontWeight: typography.fontWeightRegular
  }
}));
function ListItem(t0) {
  const $ = _c(31);
  let label;
  let otherProps;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== t0) {
    ({
      children: t1,
      className: t2,
      Component: t3,
      icon: t4,
      isIconOnRight: t5,
      label,
      selected: t6,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = otherProps;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    label = $[1];
    otherProps = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
  }
  const children = t1 === undefined ? null : t1;
  const className = t2 === undefined ? "" : t2;
  const Component = t3 === undefined ? "div" : t3;
  const ItemIcon = t4 === undefined ? null : t4;
  const isIconOnRight = t5 === undefined ? false : t5;
  const selected = t6 === undefined ? false : t6;
  let t7;
  if ($[9] !== isIconOnRight) {
    t7 = classnames({
      [classes.iconContainerOnRight]: isIconOnRight
    });
    $[9] = isIconOnRight;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const iconContainerClassname = t7;
  let iconElement = null;
  if (ItemIcon) {
    let t8;
    if ($[11] !== ItemIcon || $[12] !== iconContainerClassname || $[13] !== isIconOnRight) {
      t8 = isIconOnRight ? <ItemIcon /> : <ListItemIcon className={iconContainerClassname}><ItemIcon /></ListItemIcon>;
      $[11] = ItemIcon;
      $[12] = iconContainerClassname;
      $[13] = isIconOnRight;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    iconElement = t8;
  }
  let t8;
  if ($[15] !== className || $[16] !== selected) {
    t8 = classnames(className, classes.listItemContainer, {
      [classes.itemSelected]: selected
    });
    $[15] = className;
    $[16] = selected;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const listItemContainerClassName = t8;
  const t9 = !isIconOnRight && iconElement;
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      primary: classes.primary
    };
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== label) {
    t11 = <ListItemText classes={t10} primary={label} />;
    $[19] = label;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = isIconOnRight && iconElement;
  let t13;
  if ($[21] !== Component || $[22] !== children || $[23] !== otherProps || $[24] !== t11 || $[25] !== t12 || $[26] !== t9) {
    t13 = <MuiListItemButton className={classes.listItem} component={Component} {...otherProps}>{t9}{t11}{children}{t12}</MuiListItemButton>;
    $[21] = Component;
    $[22] = children;
    $[23] = otherProps;
    $[24] = t11;
    $[25] = t12;
    $[26] = t9;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== listItemContainerClassName || $[29] !== t13) {
    t14 = <Root className={listItemContainerClassName}>{t13}</Root>;
    $[28] = listItemContainerClassName;
    $[29] = t13;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  return t14;
}
export default ListItem;